import { render, staticRenderFns } from "./AnswerContent.vue?vue&type=template&id=2269a445"
import script from "./AnswerContent.vue?vue&type=script&lang=js"
export * from "./AnswerContent.vue?vue&type=script&lang=js"
import style0 from "./AnswerContent.vue?vue&type=style&index=0&id=2269a445&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports